export { input };

const input = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'no', header: 'No.' },
          { field: 'assetName', header: 'Asset' },
          { field: 'inputName', header: 'Input' },
          { field: 'time', header: 'Time' },
          { field: 'onTime', header: 'On Duration' },
          { field: 'onCount', header: 'On Count' },
          { field: 'offTime', header: 'Off Duration' },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'View PTO Analysis',
                  icon: 'icon-activity',
                  iconPack: 'feather',
                  click: {
                    component: 'InputReportWrapper',
                    data: {
                      onReady: (self) => {
                        let args = self.data.rowData;
                        return new Promise((resolve) => {
                          self.onReadyData = args;
                          resolve(true);
                        });
                      },
                    },
                  },
                },
              ],
            },
            hide: true,
          },
        ],
      },
      pdf: {
        title: 'Input - Summary',
        colsWidth: [51, 103, 140, 109, 101, 100, 100],
      },
    },
    {
      label: 'Breakdown',
      icon: 'event',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'inputName', header: 'Input' },
          { field: 'inputTime', header: 'On Time' },
          { field: 'inputMin2', header: 'On Duration' },
          { field: 'address', header: 'Location' },
          {
            field: 'coordinates',
            header: 'Coord',
            template: { component: 'GoogleMapLink' },
          },
          { field: 'status', header: 'Status' },
        ],
      },
      pdf: {
        title: 'Input - Breakdown',
        colsWidth: [51, 103, 140, 109, 101, 100, 100],
      },
    },
  ];
};
